import { render, staticRenderFns } from "./Tixianliebiao.vue?vue&type=template&id=eb61a1fa&scoped=true&"
import script from "./Tixianliebiao.vue?vue&type=script&lang=js&"
export * from "./Tixianliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Tixianliebiao.vue?vue&type=style&index=0&id=eb61a1fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb61a1fa",
  null
  
)

export default component.exports